import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle, useRef } from 'react';
import { Row, Col, Card, OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import PayScheduleFrequency from './PayScheduleFrequency';
import axios from 'axios';
import debounce from 'lodash/debounce';
import Select from 'react-select';
import config from '../../config';





const GeneralInfo = forwardRef(({ caseId, renewalCase, fsaDataRef, isDisableForUsers, onError = () => { }, setInformationProvider }, ref) => {
    const [generalInfo, setGeneralInfo] = useState(null);
    const [fsaStatus, setFsaStatus] = useState(false)
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});
    const payrollVendorOptions = [
        { value: "ADP", label: "ADP" },
        { value: "Asure", label: "Asure" },
        { value: "Bamboo HR", label: "Bamboo HR" },
        { value: "Benroll", label: "Benroll" },
        { value: "Ceridian", label: "Ceridian" },
        { value: "Dayforce", label: "Dayforce" },
        { value: "Ease", label: "Ease" },
        { value: "Emplova", label: "Emplova" },
        { value: "Engage PEO", label: "Engage PEO" },
        { value: "Execupay", label: "Execupay" },
        { value: "Extensis", label: "Extensis" },
        { value: "EXTENSISHR", label: "EXTENSISHR" },
        { value: "Frank Crum", label: "Frank Crum" },
        { value: "Fusion Employer Services LLC", label: "Fusion Employer Services LLC" },
        { value: "GoCo", label: "GoCo" },
        { value: "GovCon Pay iSolved", label: "GovCon Pay iSolved" },
        { value: "Gusto", label: "Gusto" },
        { value: "HRP", label: "HRP" },
        { value: "INOVA", label: "INOVA" },
        { value: "Integrated Payroll Systems Inc", label: "Integrated Payroll Systems Inc" },
        { value: "iSolve", label: "iSolve" },
        { value: "iSolved (PNIHCM)", label: "iSolved (PNIHCM)" },
        { value: "Iuvosystems", label: "Iuvosystems" },
        { value: "Justworks", label: "Justworks" },
        { value: "Kelly Benefits", label: "Kelly Benefits" },
        { value: "Namely", label: "Namely" },
        { value: "One Source", label: "One Source" },
        { value: "OneDigi", label: "OneDigi" },
        { value: "Paychex", label: "Paychex" },
        { value: "Paycom", label: "Paycom" },
        { value: "Paycor", label: "Paycor" },
        { value: "Payday", label: "Payday" },
        { value: "PayEntry", label: "PayEntry" },
        { value: "Payroll Analyst II Talent Solutions HR Payroll and Systems", label: "Payroll Analyst II Talent Solutions HR Payroll and Systems" },
        { value: "Payroll Dynamics", label: "Payroll Dynamics" },
        { value: "Paylocity", label: "Paylocity" },
        { value: "Payroll Systems", label: "Payroll Systems" },
        { value: "Payserve", label: "Payserve" },
        { value: "Plan Source", label: "Plan Source" },
        { value: "PNI", label: "PNI" },
        { value: "PNI HCM", label: "PNI HCM" },
        { value: "PNI HCM GovConPay", label: "PNI HCM GovConPay" },
        { value: "Prestige PEO", label: "Prestige PEO" },
        { value: "Prime Pay", label: "Prime Pay" },
        { value: "Prime Point", label: "Prime Point" },
        { value: "PrimePoint", label: "PrimePoint" },
        { value: "Rippling", label: "Rippling" },
        { value: "SDP", label: "SDP" },
        { value: "Selerix", label: "Selerix" },
        { value: "Staffpro", label: "Staffpro" },
        { value: "Steve Dawes CP", label: "Steve Dawes CP" },
        { value: "UKG", label: "UKG" },
        { value: "Ultimate Software", label: "Ultimate Software" },
        { value: "Viventium", label: "Viventium" },
        { value: "Workday", label: "Workday" },
        { value: "Wurk", label: "Wurk" },
        { value: "Other", label: "Other" }
    ];
    const onlyHra = renewalCase?.products === 'HRA'
    const payscheduleRef = useRef();

    useEffect(() => {
        const fetchGeneralInfo = async () => {
            try {
                const response = await axios.get(`${config.API_URL}/EBGeneralInformations/ByCaseId/${caseId}`);

                if (fsaDataRef.current && typeof fsaDataRef.current.validateAll === 'function') {
                    const fsaLenght = fsaDataRef.current.fsaLenght;
                    const dcaLenght = fsaDataRef.current.fsaLenght;
                    const lpfsaLenght = fsaDataRef.current.lpfsaLenght;
                    
                    if(fsaLenght > 0 || dcaLenght > 0 || lpfsaLenght > 0){
                        setFsaStatus(true)
                    }
                    
                  }
                setGeneralInfo(response.data || null);
                
                  
                setInformationProvider(response.data?.informationProvider)  
                
            } catch (error) {
                setError('Error fetching plans.');
            } finally {
                setLoading(false);
            }
        };
        fetchGeneralInfo();
        
    }, [caseId]);

    const debouncedUpdateOnlyHRA = useCallback(
        debounce(async (id) => {
            
            const updatedFields= {'informationProvider': 'Prefunded HRA' }
           
            try {
                const patchDocument = Object.keys(updatedFields).map(key => ({
                    path: `/${key}`,
                    value: updatedFields[key]
                }));
                await axios.patch(`${config.API_URL}/EBGeneralInformations/${id}`, patchDocument);
                setGeneralInfo(prevInfo => {
                    const updatedInfo = { ...prevInfo, 'informationProvider': 'Prefunded HRA' };
                    return updatedInfo;
                });
            } catch (error) {
                console.error('Error updating plan:', error);
                onError(error);
            }

        }, 500),
        [onError, validationErrors, caseId]
    );

    const debouncedUpdate = useCallback(
        debounce(async (updatedFields) => {

            try {
                const patchDocument = Object.keys(updatedFields).map(key => ({
                    path: `/${key}`,
                    value: updatedFields[key]
                }));
                await axios.patch(`${config.API_URL}/EBGeneralInformations/${generalInfo?.id}`, patchDocument);
            } catch (error) {
                console.error('Error updating plan:', error);
                onError(error);
            }

        }, 500),
        [onError, validationErrors, caseId]
    );

    const validateField = (name, value) => {
        let errors = { ...validationErrors };

        switch (name) {
            
            case 'payrollProviderVendorName':
                if (generalInfo?.informationProvider?.includes('Vendor File') && !value) {
                    errors[name] = 'Payroll vendor name is required';
                } else {
                    delete errors[name];
                }
                break;
                case 'payrollProviderOtherVendorName':
                if (generalInfo?.informationProvider?.includes('Vendor File') && generalInfo.payrollProviderVendorName ==="Other" && !value) {
                    errors[name] = 'Other Payroll vendor name is required';
                } else {
                    delete errors[name];
                }
                break;
                
                case 'payrollProviderContactEmail':
                if (generalInfo?.informationProvider?.includes('Vendor File') && !value && !value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                    errors[name] = 'Payroll vendor contact email is required';
                } else {
                    delete errors[name];
                }
                break;

            default:
                break;
        }

        setValidationErrors(errors);
    };

    const validateAll = () => {
        let allValid = true;
        let errors = { ...validationErrors };
    
        // Check payrollProviderVendorName
        if (generalInfo?.informationProvider?.includes('Vendor File') && !generalInfo?.payrollProviderVendorName) {
            errors['payrollProviderVendorName'] = 'Payroll vendor name is required';
        } else {
            delete errors['payrollProviderVendorName'];
        }
    
        // Check payrollProviderOtherVendorName
        if (generalInfo?.informationProvider?.includes('Vendor File') && generalInfo.payrollProviderVendorName === "Other" && !generalInfo?.payrollProviderOtherVendorName) {
            errors['payrollProviderOtherVendorName'] = 'Other Payroll vendor name is required';
        } else {
            delete errors['payrollProviderOtherVendorName'];
        }
    
       
    
        // Check payrollProviderContactEmail
        if (generalInfo?.informationProvider?.includes('Vendor File') && (!generalInfo?.payrollProviderContactEmail || !generalInfo?.payrollProviderContactEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))) {
            errors['payrollProviderContactEmail'] = 'Payroll vendor contact email is required';
        } else {
            delete errors['payrollProviderContactEmail'];
        }
    
        setValidationErrors(errors);

        if(Object.keys(errors).length === 0){
            allValid = true;
        }else{
            allValid=false
        }

        if (payscheduleRef.current) {
            const payscheduleRefValid = payscheduleRef.current.validateAll();
            if (!payscheduleRefValid) {
                allValid = false;
            }
        }

       
        
    
        // Return true if no errors, false if there are errors
        //return Object.keys(errors).length === 0;
        return allValid;
    };

    useImperativeHandle(ref, () => ({
        validateAll,
        getFormData: () => generalInfo, 
    }));
    

    const handleToggleChange = (e, toggleValue, property) => {
        const { checked } = e.target;
        
        if(!fsaStatus){
            
            const value = checked ? toggleValue : 'false';
            setGeneralInfo(prevInfo => {
                const updatedInfo = { ...prevInfo, [property]: value };
                debouncedUpdate({ [property]: value });
                return updatedInfo;
            });

        }else{
            
            
            setGeneralInfo(prevInfo => {
                const updatedInfo = { ...prevInfo, [property]: toggleValue };
                debouncedUpdate({ [property]: toggleValue });
                return updatedInfo;
            });
        }

        if (property === 'informationProvider') {
            setInformationProvider(toggleValue);
        }
        
        
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        validateField(name, value);
        setGeneralInfo(prevInfo => {
            const updatedInfo = { ...prevInfo, [name]: value };
            debouncedUpdate({ [name]: value });
            return updatedInfo;
        });
    };

    const handleSelectChange = (selectedOption, { name }) => {
        const value = selectedOption ? selectedOption.value : '';
        validateField(name, value);
        setGeneralInfo(prevInfo => {
            const updatedInfo = { ...prevInfo, [name]: value };
            debouncedUpdate({ [name]: value });
            return updatedInfo;
        });
    };

    const customStyles = (hasError) => ({
        control: (provided) => ({
            ...provided,
            borderColor: hasError ? '#dc3545' : provided.borderColor,
            '&:hover': {
                borderColor: hasError ? '#dc3545' : provided.borderColor,
            },
            boxShadow: hasError ? '0 0 10px rgba(220, 53, 69, 0.5)' : provided.boxShadow,
        }),
    });

    if (
        onlyHra &&
        ![
          'Autopost',
          'Contribution Manager',
          'Client File',
          'Vendor File',
          'Prefunded HRA'
        ].includes(generalInfo?.informationProvider?.trim())
      ) {
        debouncedUpdateOnlyHRA(generalInfo?.id);
      }

    //const isDisabled = renewalCase?.ebSubmissionStatus === 'Submitted' || isDisableForUsers;
    const isDisabled =  isDisableForUsers;

    return (
        <Col lg={12} className='mb-3'>
            <Card>
                <Card.Body>
                    <Card.Title>General Information </Card.Title>
                    <Row className="mb-3">
    <Col lg={12} className="mb-3">
        <span>
            How will Clarity receive ongoing contribution data to credit participant accounts?
        </span>
    </Col>
    <Col lg={onlyHra ? 1 : 2} className="pe-0 d-flex">
        <Card className="h-100">
            <Card.Body>
                <div className="d-flex align-items-center">
                    <Form.Label>
                        Autopost
                    </Form.Label>
                    <div className="form-check form-switch form-toggle">
                        <input
                            type="checkbox"
                            className="form-check-input form-check-input-toggel toggle-input-switch"
                            role="switch"
                            checked={generalInfo?.informationProvider === "Autopost"}
                            onChange={(e) => handleToggleChange(e, 'Autopost', 'informationProvider')}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
                <span className="mt-3">This method allows employee contributions to be automatically posted to their plans based on prebuilt payroll calendar(s) reported by the administrator. This method works for all benefit plans except HSA.</span>
            </Card.Body>
        </Card>
    </Col>
    <Col lg={onlyHra ? 1 : 2} className="ps-0 pe-0 d-flex">
        <Card className="h-100">
            <Card.Body>
                <div className="d-flex align-items-center">
                    <Form.Label>
                        Contribution Manager
                    </Form.Label>
                    <div className="form-check form-switch form-toggle">
                        <input
                            type="checkbox"
                            className="form-check-input form-check-input-toggel toggle-input-switch"
                            role="switch"
                            checked={generalInfo?.informationProvider === "Contribution Manager"}
                            onChange={(e) => handleToggleChange(e, 'Contribution Manager', 'informationProvider')}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
                <span>
                    This method allows administrators to confirm and load participant contributions directly through our portal. This method is ideal for companies with fewer than 25 enrollments. Click <a href='https://vimeo.com/602157531' target='_blank'>here</a> to learn more.
                </span>
            </Card.Body>
        </Card>
    </Col>
    <Col lg={onlyHra ? 1 : 2} className="ps-0 pe-0 d-flex">
        <Card className="h-100">
            <Card.Body>
                <div className="d-flex align-items-center">
                    <Form.Label>
                        Deposit File from Client
                    </Form.Label>
                    <div className="form-check form-switch form-toggle">
                        <input
                            type="checkbox"
                            className="form-check-input form-check-input-toggel toggle-input-switch"
                            role="switch"
                            checked={generalInfo?.informationProvider === "Client File"}
                            onChange={(e) => handleToggleChange(e, 'Client File', 'informationProvider')}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
                <span>
                Using this method, administrators upload a deposit template on the Clarity website using our File Manager tool.  This is ideal for companies with over 25 enrollments.
                </span>
            </Card.Body>
        </Card>
    </Col>
    <Col lg={onlyHra ? 1 : 2} className="ps-0 pe-0 d-flex">
        <Card className="h-100">
            <Card.Body>
                <div className="d-flex align-items-center">
                    <Form.Label>
                        Deposit File from Payroll Vendor
                    </Form.Label>
                    <div className="form-check form-switch form-toggle">
                        <input
                            type="checkbox"
                            className="form-check-input form-check-input-toggel toggle-input-switch"
                            role="switch"
                            checked={generalInfo?.informationProvider === "Vendor File"}
                            onChange={(e) => handleToggleChange(e, 'Vendor File', 'informationProvider')}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
                <span>
                    Using this method, administrators send deposit files to Clarity for import. This can be done manually or via an automated file exchange with almost any payroll provider. This method is ideal for companies with over 25 enrollments.
                </span>
            </Card.Body>
        </Card>
    </Col>
    <Col lg={onlyHra ? 1 : 2} className="ps-0 pe-0 d-flex">
        <Card className="h-100">
            <Card.Body>
                <div className="d-flex align-items-center">
                    <Form.Label>
                    ADP Marketplace
                    </Form.Label>
                    <div className="form-check form-switch form-toggle">
                        <input
                            type="checkbox"
                            className="form-check-input form-check-input-toggel toggle-input-switch"
                            role="switch"
                            checked={generalInfo?.informationProvider === "ADP Marketplace"}
                            onChange={(e) => handleToggleChange(e, 'ADP Marketplace', 'informationProvider')}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
                <span className="mt-3">This option allows ADP to send payroll data in real time with no feed setup / testing required.  You must supply the ADP Payroll codes that you set up in the ADP system for each benefit being offered with Clarity.</span>
            </Card.Body>
        </Card>
    </Col>
    {onlyHra && (
        <Col lg={onlyHra ? 1 : 2} className="ps-0 d-flex">
        <Card className="h-100">
            <Card.Body>
                <div className="d-flex align-items-center">
                    <Form.Label>
                        Does not apply we only offer prefunded HRA Plan(s)"
                    </Form.Label>
                    <div className="form-check form-switch form-toggle">
                        <input
                            type="checkbox"
                            className="form-check-input form-check-input-toggel toggle-input-switch"
                            role="switch"
                            checked={generalInfo?.informationProvider === 'Prefunded HRA'}
                            onChange={(e) => handleToggleChange(e, 'Prefunded HRA', 'informationProvider')}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
                
            </Card.Body>
        </Card>
    </Col>
    )}
    
</Row>

<Row>
    {generalInfo?.informationProvider === "Vendor File" && (
        <>
            <Col lg={3}>
                <Form.Group lg={12} className="mb-3">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Payroll vendor name</Tooltip>}
                    >
                        <Select
                            name="payrollProviderVendorName"
                            placeholder="Payroll Vendor Name"
                            options={payrollVendorOptions}
                            isInvalid={!!validationErrors.payrollProviderVendorName}
                            value={payrollVendorOptions.find(option => option.value === generalInfo?.payrollProviderVendorName)}
                            onChange={handleSelectChange}
                            styles={customStyles(validationErrors && validationErrors.payrollProviderVendorName)}
                            isDisabled={isDisabled}
                        />
                    </OverlayTrigger>
                    {validationErrors.payrollProviderVendorName && (
                        <div className="invalid-feedback d-block">
                            {validationErrors.payrollProviderVendorName}
                        </div>
                    )}
                </Form.Group>
            </Col>

            <Col lg={3}>
                <Form.Group className="mb-3">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Payroll Vendor Contact First Name.</Tooltip>}
                    >
                        <Form.Control
                            type="text"
                            name='payrollProviderFirstName'
                            isInvalid={!!validationErrors.payrollProviderFirstName}
                            value={generalInfo?.payrollProviderFirstName || ''}
                            onChange={handleInputChange}
                            placeholder="Payroll Vendor Contact First Name"
                            disabled={isDisabled}
                            />
                        </OverlayTrigger>
                        {validationErrors.payrollProviderFirstName && (
                            <div className="invalid-feedback d-block">
                                {validationErrors.payrollProviderFirstName}
                            </div>
                        )}
                </Form.Group>
            </Col>

            <Col lg={3}>
                <Form.Group className="mb-3">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Payroll Vendor Contact Last Name</Tooltip>}
                    >
                        <Form.Control
                            type="text"
                            name='payrollProviderLastName'
                            value={generalInfo?.payrollProviderLastName || ''}
                            isInvalid={!!validationErrors.payrollProviderLastName}
                            onChange={handleInputChange}
                            placeholder="Payroll Vendor Contact Last Name"
                            disabled={isDisabled}
                            />
                        </OverlayTrigger>
                        {validationErrors.payrollProviderLastName && (
                            <div className="invalid-feedback d-block">
                                {validationErrors.payrollProviderLastName}
                            </div>
                        )}
                </Form.Group>
            </Col>

            <Col lg={3}>
                <Form.Group className="mb-3">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Payroll Vendor Contact Email</Tooltip>}
                    >
                        <Form.Control
                            type="text"
                            name='payrollProviderContactEmail'
                            value={generalInfo?.payrollProviderContactEmail || ''}
                            isInvalid={!!validationErrors.payrollProviderContactEmail}
                            onChange={handleInputChange}
                            placeholder="Payroll Vendor Contact Email"
                            disabled={isDisabled}
                            />
                        </OverlayTrigger>
                        {validationErrors.payrollProviderContactEmail && (
                            <div className="invalid-feedback d-block">
                                {validationErrors.payrollProviderContactEmail}
                            </div>
                        )}
                </Form.Group>
            </Col>

            {generalInfo?.payrollProviderVendorName === "Other" && (
                <Col lg={3}>
                    <Form.Group className="mb-3">
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Other Payroll Vendor Name</Tooltip>}
                        >
                            <Form.Control
                                type="text"
                                name='payrollProviderOtherVendorName'
                                value={generalInfo?.payrollProviderOtherVendorName || ''}
                                isInvalid={!!validationErrors.payrollProviderOtherVendorName}
                                onChange={handleInputChange}
                                placeholder="Other Payroll Vendor Name"
                                disabled={isDisabled}
                                />
                                </OverlayTrigger>
                                {validationErrors.payrollProviderOtherVendorName && (
                                    <div className="invalid-feedback d-block">
                                        {validationErrors.payrollProviderOtherVendorName}
                                    </div>
                                )}
                    </Form.Group>
                </Col>
            )}
        </>
    )}
</Row>

                    {!(generalInfo?.informationProvider === 'Prefunded HRA') &&(
                    <Row >
                        <Col lg={12}>
                            <PayScheduleFrequency
                                ref={payscheduleRef}
                                caseId={caseId}
                                renewalCase={renewalCase}
                                isDisableForUsers={isDisableForUsers}
                                initialFormValues={{}} />
                        </Col>
                    </Row>
)}
                </Card.Body>
            </Card>
        </Col>
    );
});

export default GeneralInfo;